import React from "react";
import classnames from "classnames";
import {isRTL} from "../../../services/userModel";
import './index.scss';

const SectionNestedItem = ({column, item, value}) => {
    const margin = item.tabMode * column.nestedTab + 'px';
    const style = {
        margin: isRTL() ? `0 ${margin} 0 0` : `0 0 0 ${margin}`
    }
    return (
        <div className={classnames("nestedItem")} style={style}>
            {value}
            {item.usedSearch && item.parentValue && (<span className={"nestedItemParent"}>&nbsp;({item.parentValue.trim()})</span>)}
        </div>
    )
}

export default SectionNestedItem;
